"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _i18nJs = require("i18n-js");
var _sbVerbiage = _interopRequireDefault(require("@simplybenefits/sb-verbiage"));
var i18n = new _i18nJs.I18n({
  en: _sbVerbiage["default"].translations.english,
  fr: _sbVerbiage["default"].translations.french
});
i18n.locale = "en"; // TODO: change this back to Localization.locale;
i18n.fallbacks = true;
i18n.toggleLocale = function () {
  i18n.locale = i18n.locale === 'en' ? 'fr' : 'en';
};
i18n.setLocale = function (locale) {
  i18n.locale = locale;
};
var _default = exports["default"] = i18n;